var ResultSort = React.createClass({
    propTypes: {
        sortKeys: React.PropTypes.array.isRequired,
        selectedIndex: React.PropTypes.number,
        onSortChanged: React.PropTypes.func,
        align: React.PropTypes.oneOf(["left", "center", "right"])
    }, getDefaultProps() {
        return {
            selectedIndex: 0, onSortChanged: function () {
            }, align: "right"
        }
    }, sortChanged(e) {
        let selectedIndex = parseInt(e.currentTarget.value);
        let selectedKey = this.props.sortKeys[selectedIndex];

        this.props.onSortChanged(selectedKey, selectedIndex);
    }, componentDidMount: function () {
        try {
            $('.result-sort__control').selectpicker('refresh');
        } catch (e) {
            //Do nothing in case bootstrap-select library is not found.
        }
    }, componentDidUpdate: function () {
        try {
            $('.result-sort__control').selectpicker('refresh');
        } catch (e) {
            //Do nothing in case bootstrap-select library is not found.
        }
    }, render() {
        let {
            sortKeys, selectedIndex, align
        } = this.props;
        let className = (align === "right" || align === "center") ? " -" + align : "";

        return (<form hidden={selectedIndex === -1} id="resultSortForm"
                      className={"result-sort form-inline" + className + " col-xs-6 col-lg-4"}>
            <div className="has-float-label">
                <select id="resultSort"
                        name="resultSort"
                        className="form-control result-sort__control"
                        value={selectedIndex} onChange={this.sortChanged}>
                    {sortKeys.map((sortKey, i) => <option key={i} value={i}>{sortKey.label}</option>)}
                </select>
                <label htmlFor="resultSort" className="result-sort__label">{Labels.getLabel("Sort") + ":"}</label>
            </div>
        </form>)
    }
});